import { inject } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { MsalService } from "@azure/msal-angular";

import { isSurveyCreatorAdmin, toRoleList } from "./survey-edit-permissions";

/**
 * Survey Admin Guard
 * Restricts a route to accounts holding the ct-admin app role (the Survey
 * Creator Admin). notification-service enforces the same role on its rule
 * routes, so a user turned away here would be refused by the API too.
 *
 * Usage in routes:
 * {
 *   path: 'notifications',
 *   canActivate: [authGuard, surveyAdminGuard],
 * }
 */
export const surveyAdminGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  const roles: string[] = toRoleList(msalService.instance.getActiveAccount()?.idTokenClaims?.roles);
  if (isSurveyCreatorAdmin(roles)) {
    return true;
  }

  console.warn("User lacks the ct-admin role; blocking navigation to an admin-only page");
  return router.createUrlTree(["/survey-manager"]);
};
